export default (str, divide = false) => ({
  r: parseInt(str.slice(1, 3), 16) / (divide ? 255 : 1),
  g: parseInt(str.slice(3, 5), 16) / (divide ? 255 : 1),
  b: parseInt(str.slice(5, 7), 16) / (divide ? 255 : 1),
  a: str.length > 7 ? parseInt(str.slice(7), 16) / 255 : 1,
});
